module.exports = __webpack_public_path__ + "img/SDG-06-EN-INVERTED.8342e6ad.png";